function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.04349 13.0898H6.26086C5.87686 13.0898 5.56519 13.4015 5.56519 13.7855V19.3506C5.56519 19.7346 5.87686 20.0463 6.26086 20.0463C6.64486 20.0463 6.95653 19.7346 6.95653 19.3506V14.4811H9.04349C9.42749 14.4811 9.73916 14.1694 9.73916 13.7854C9.73916 13.4014 9.42749 13.0898 9.04349 13.0898Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.65215 15.8724H6.26086C5.87686 15.8724 5.56519 16.1841 5.56519 16.5681C5.56519 16.9521 5.87686 17.2637 6.26086 17.2637H7.65215C8.03615 17.2637 8.34783 16.952 8.34783 16.568C8.34783 16.184 8.03615 15.8724 7.65215 15.8724Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16 0C7.17775 0 0 7.17775 0 16C0 24.8222 7.17775 31.9999 16 31.9999C24.8222 31.9999 31.9999 24.8222 31.9999 16C31.9999 7.17775 24.8222 0 16 0ZM16 30.6087C7.94432 30.6087 1.39128 24.0556 1.39128 16C1.39128 7.94432 7.94432 1.39128 16 1.39128C24.0556 1.39128 30.6087 7.94432 30.6087 16C30.6087 24.0556 24.0556 30.6087 16 30.6087Z",
  fill: "current"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.223 9.17606C22.9621 6.35868 19.6008 4.742 16 4.742C12.3993 4.742 9.03794 6.35868 6.77705 9.17606C6.53633 9.47521 6.58368 9.91347 6.8842 10.1541C7.18335 10.3948 7.62161 10.3475 7.86089 10.047C9.8574 7.55933 12.8237 6.13322 16 6.13322C19.1764 6.13322 22.1427 7.55933 24.1378 10.047C24.2755 10.2181 24.4773 10.3071 24.6804 10.3071C24.8349 10.3071 24.9879 10.257 25.1159 10.1541C25.4164 9.91347 25.4637 9.47521 25.223 9.17606Z",
  fill: "current"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5482 23.7152C24.2727 23.4523 23.8303 23.4634 23.566 23.7416C21.5695 25.8439 18.8829 27.0028 16 27.0028C13.1172 27.0028 10.4307 25.8439 8.43555 23.7416C8.1726 23.4606 7.73016 23.4523 7.45331 23.7152C7.17229 23.9796 7.16251 24.4206 7.4269 24.6989C9.68779 27.0822 12.7319 28.3942 16.0001 28.3942C19.2683 28.3942 22.3124 27.0822 24.5747 24.6989C24.839 24.4206 24.8279 23.9796 24.5482 23.7152Z",
  fill: "current"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4873 17.2456C14.5112 17.1134 15.3043 16.2355 15.3043 15.1767C15.3043 14.0261 14.368 13.0898 13.2173 13.0898H11.826C11.442 13.0898 11.1304 13.4015 11.1304 13.7855V16.5625C11.1304 16.5653 11.1304 16.5695 11.1304 16.5722V19.3506C11.1304 19.7346 11.442 20.0463 11.826 20.0463C12.21 20.0463 12.5217 19.7346 12.5217 19.3506V18.2474L14.1162 19.8432C14.2525 19.9781 14.4306 20.0463 14.6087 20.0463C14.7868 20.0463 14.9648 19.9782 15.0998 19.8418C15.3711 19.5705 15.3711 19.1294 15.0998 18.8581L13.4873 17.2456ZM12.5217 15.8724V14.4811H13.2174C13.6 14.4811 13.9131 14.7928 13.9131 15.1768C13.9131 15.5608 13.6 15.8725 13.2174 15.8725H12.5217V15.8724Z",
  fill: "current"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1739 18.655H18.0869V14.4811H20.1739C20.5579 14.4811 20.8695 14.1694 20.8695 13.7854C20.8695 13.4014 20.5579 13.0898 20.1739 13.0898H17.3912C17.0072 13.0898 16.6956 13.4015 16.6956 13.7855V19.3506C16.6956 19.7346 17.0072 20.0463 17.3912 20.0463H20.1739C20.5579 20.0463 20.8695 19.7346 20.8695 19.3506C20.8695 18.9666 20.5579 18.655 20.1739 18.655Z",
  fill: "current"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7825 15.8724H17.3912C17.0072 15.8724 16.6956 16.1841 16.6956 16.5681C16.6956 16.9521 17.0072 17.2637 17.3912 17.2637H18.7825C19.1665 17.2637 19.4782 16.952 19.4782 16.568C19.4782 16.184 19.1665 15.8724 18.7825 15.8724Z",
  fill: "current"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M25.7391 18.655H23.6521V14.4811H25.7391C26.1231 14.4811 26.4347 14.1694 26.4347 13.7854C26.4347 13.4014 26.1231 13.0898 25.7391 13.0898H22.9564C22.5724 13.0898 22.2607 13.4015 22.2607 13.7855V19.3506C22.2607 19.7346 22.5724 20.0463 22.9564 20.0463H25.7391C26.1231 20.0463 26.4347 19.7346 26.4347 19.3506C26.4347 18.9666 26.1231 18.655 25.7391 18.655Z",
  fill: "current"
});

function SvgFree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFree);
export default __webpack_public_path__ + "static/media/Free.d8512cc3.svg";
export { ForwardRef as ReactComponent };